export default class Timer {
    constructor() {
        const el = document.querySelector<HTMLElement>('[data-timer]')
        if (el) new TimerInstance(el)
    }
}

class TimerInstance {
    private el: HTMLElement
    private id: string
    private start: number
    private end: number
    private isBanner: boolean

    constructor(el: HTMLElement) {
        this.el = el
        this.id = el.dataset.timerId || ''
        this.start = new Date(el.dataset.timerStart || '').getTime()
        this.end = new Date(el.dataset.timerEnd || '').getTime()
        this.isBanner = el.dataset.timerMode === 'banner'

        const now = Date.now()
        if (isNaN(this.end) || now >= this.end) {
            this.removeTimer()
            return
        }

        this.updateDays(now)
        this.scheduleHide(now)

        if (this.isBanner) this.initBanner()
        else this.initPopup()
    }

    // the banner sits in flow above the fixed menu; expose its height so the
    // open menu can offset for it the same way it does for the alert
    private initBanner() {
        this.setBannerHeight()
        window.addEventListener('resize', () => this.setBannerHeight())
    }

    private setBannerHeight() {
        document.documentElement.style.setProperty(
            '--timer-height',
            `${this.el.offsetHeight}px`
        )
        document.documentElement.setAttribute('data-timer-banner', '')
    }

    private removeTimer() {
        if (this.isBanner) {
            document.documentElement.removeAttribute('data-timer-banner')
            document.documentElement.style.removeProperty('--timer-height')
        }
        this.el.remove()
    }

    private updateDays(now: number) {
        const days = Math.max(1, Math.ceil((this.start - now) / 86400000))
        const numEl = this.el.querySelector('[data-timer-days]')
        const unitEl = this.el.querySelector('[data-timer-unit]')
        if (numEl) numEl.textContent = String(days)
        if (unitEl) {
            unitEl.textContent = days === 1 ? this.el.dataset.timerUnitOne || '' : this.el.dataset.timerUnitMany || ''
        }
    }

    private scheduleHide(now: number) {
        const ms = this.end - now
        if (ms > 0 && ms < 86400000) {
            window.setTimeout(() => this.removeTimer(), ms)
        }
    }

    private initPopup() {
        window.requestAnimationFrame(() => this.el.classList.add('is-visible'))
        const closeBtn = this.el.querySelector('[data-timer-close]')
        closeBtn?.addEventListener('click', () => this.dismiss())
    }

    private dismiss() {
        document.cookie = `timer-${this.id}=false;path=/`
        this.el.classList.remove('is-visible')
        this.el.addEventListener('transitionend', () => this.el.remove(), {once: true})
        window.setTimeout(() => this.el.remove(), 400)
    }
}
